// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TicketAttachment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Types = {
        Scale: 1,
        RediMix: 2,
    };

    get typeName() {
        return this.typeId === 1 ? 'Scale' : this.typeId === 2 ? 'Redi-Mix' : 'Manual';
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  filename?: string;
  name?: string;
  notes?: string;
  typeId?: number;
}

